var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSyncing)?_c('div',{staticClass:"sync-status-container"},[_c('div',{staticClass:"sync-status"},[_c('v-icon',{staticClass:"sync-icon rotating"},[_vm._v("fas fa-sync")]),_c('span',{staticClass:"sync-text"},[_vm._v("Syncing...")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }